export function cardWithIconSlider() {
    const $window = $(window);
    const $slider = $(".card-with-icon-slider");
    let sliderNav = "";

    function mobileSlider() {
        $slider.each(function () {
            let $this = $(this);
            sliderNav = $this.next(".card-with-icon-slider-nav");
            $this.not('.slick-initialized').slick({
                dots: true,
                appendDots: sliderNav,
                arrows: true,
                appendArrows: sliderNav,
                infinite: false,
                speed: 700,
                cssEase: 'ease',
                slidesToShow: 1.36,
                slidesToScroll: 1,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 1023,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                        }
                    },
                ]
            });
            if ($window.innerWidth() >= 1024) {
                if ($this.hasClass("slick-initialized") && $this.hasClass("slider-on-mobile")) {
                    $this.slick('refresh');
                    $this.slick('unslick');
                }
            }
        });
    }

    $window.on("load resize", function () {
        mobileSlider();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/cardWithIconSlider.js